'use strict';

var NewColumnNameValidation = function NewColumnNameValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        var valid = true;
        if (value && value.length) {
          valid = scope.isValidNewColumnName(value);
          ctrl.$setValidity('columnNameAlreadyUsed', valid);
        } else {
          ctrl.$setValidity('columnNameAlreadyUsed', true);
        }
        return valid ? value : undefined;
      });
    }
  };
};
NewColumnNameValidation.$inject = [];
module.exports = NewColumnNameValidation;